module.exports = __webpack_public_path__ + "static/media/z.67a63446.JPG";